import { getApiBaseUrl } from '../../../api/config';

function apiUrl(path) {
  return `${getApiBaseUrl()}${path}`;
}

export function getCreateStorefrontAuthorizeCheckoutUrl() {
  return apiUrl('/api/payments/storefront/authorize/checkout');
}

export function getCreateStorefrontDeluxeCheckoutUrl() {
  return apiUrl('/api/payments/storefront/deluxe/checkout');
}

export function getChargeStorefrontDeluxeCheckoutUrl() {
  return apiUrl('/api/payments/storefront/deluxe/charge');
}
